
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/data-request-policy",
      function () {
        return require("private-next-pages/data-request-policy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/data-request-policy"])
      });
    }
  